import React from "react";
import { Typography, Box, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import pMarkLogo from "images/logo/pmark_75.gif"; // Adjust path as needed
import PrivacyMarkXs from "./small-ui/PrivacyMarkXs";

const PrivacyMark = ({ id, isXs }) => {
  const { t } = useTranslation();

  if (isXs) return <PrivacyMarkXs id={id} />;

  return (
    <Paper elevation={1} sx={{ p: 4, mb: 4 }} id={id}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <Box
          component="img"
          src={pMarkLogo}
          alt="P Mark Logo"
          sx={{ width: 40, height: 40 }}
        />
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{ ml: 2 }}
        >
          {t("privacy-policy.privacy-mark.title")}
        </Typography>
      </Box>

      <Typography paragraph>
        {t("privacy-policy.privacy-mark.description")}
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", my: 2 }}>
        <i className="fas fa-chevron-right" style={{ color: "#0c4d96" }}></i>
        <Typography sx={{ ml: 2 }}>
          {t("privacy-policy.privacy-mark.registration")}
        </Typography>
      </Box>
    </Paper>
  );
};

export default PrivacyMark;
